import {Divider, message, Tag, Tooltip, Button} from "antd";
import React from "react";
import { useHistory } from "react-router-dom";
import {ApiService, handlerError} from "../services/api/ApiService";
import Icon from "../components/util-components/Icon";
import * as AntdIcons from "@ant-design/icons";
import {transformField} from "./TransformFormDashboard";
import moment from "moment";

//Añado un search para que no añada renders a las columnas que necesitan filtro o buscador
export const transformColumn = (headers, search) => {
  return headers?.map(o => {
    if(o.action)
      return {
        title: o.title,
        dataIndex: o.dataIndex,
        key: o.dataIndex,
        width: o.width,
        render: (data, record) => (
          <span>
            {data?.map((action, index) => (<TransformAction action={action} record={record} isLast={index === data.length - 1}/>))}
          </span>
        ),
      }
    if(o.children)
      return {
        title: o.title,
        children: transformColumn(o.children)
      }
    else
      return {
        title: o.title,
        dataIndex: o.dataIndex,
        key: o.dataIndex,
        fixed: o.fixed,
        width: o.width,
        ...(!search && {
          render: (text) => (
            <span dangerouslySetInnerHTML={{ __html: text }} />
          ),
        }),
      }

  })
}

// {
//   type: tipo de acción,
//   link: url destino
//   operation: opración API
//   name: nombre del botón
// }

const callApi = (action, record, history) => {
  ApiService.post('', {tipo: action.operation, data: record})
    .then(res => {
      message.success({content: res.data.data?.text ?? 'Acción realizada', duration: 2});
      if(action.link)
        history.push(action.link)
    })
    .catch(handlerError);
}


const TransformAction = ({action, record, isLast}) => {
  let history = useHistory();
  
  // Función para renderizar el contenido interno (texto o icono)
  const renderContent = () => {
    return !action.icon ? 
      <span className={!action.color ? 'text-primary' : ''}>{action.name}</span> : 
      null;
  };

  // Función para manejar el click según el tipo de acción
  const handleClick = () => {
    switch (action.type) {
      case "operation":
        return () => callApi(action, record, history);
      case "new-tab":
        return () => window.open(action.link, "_blank");
      case "link":
      case "tag-color":
        return () => action.link ? history.push(action.link) : undefined;
      default:
        return () => {};
    }
  };

  // Renderiza el elemento como tag
  const renderTag = () => {
    const tagContent = (
      <Tag color={action.color ?? "blue"}>
        {action.name}
      </Tag>
    );

    if (action.link) {
      return (
        <a onClick={handleClick()}>
          {tagContent}
        </a>
      );
    }
    return tagContent;
  };

  // Renderiza el elemento como botón o enlace según la propiedad isLink
  const renderElement = () => {
    // Si es tipo tag-color, renderizamos un tag
    if (action.type === "tag-color") {
      return renderTag();
    }

    // Si se especifica isLink, renderizamos como enlace
    if (action.isLink) {
      return (
        <>
          <a 
            className={`mr-2 ${!action.color ? 'text-primary' : ''}`}
            style={action.color ? {color: action.color} : {}}
            onClick={handleClick()}
          >
            {action.icon && <Icon type={AntdIcons[action.icon]} style={action.color ? {color: action.color} : {}} className={!action.color ? 'text-primary' : ''} />}
            {renderContent()}
          </a>
          {!isLast && <span className="mr-2">|</span>}
        </>
      );
    } 
    
    // Por defecto, renderizamos como botón
    return (
      <Button 
        type="default" 
        className={`mr-2 ${!action.color ? 'text-primary' : ''}`}
        size="small"
        style={action.color ? {color: action.color} : {}}
        icon={action.icon ? <Icon type={AntdIcons[action.icon]} style={action.color ? {color: action.color} : {}} className={!action.color ? 'text-primary' : ''} /> : null}
        onClick={handleClick()}
      >
        {renderContent()}
      </Button>
    );
  };

  // Envuelve el elemento en un Tooltip si hay ayuda definida
  return (
    <Tooltip title={action.help}>
      {renderElement()}
    </Tooltip>
  );
}


// Table-Form

export const transformSectionForm = (section) => {
  section.fields = section.fields.map(transformField);
  return section;
}

export const transformFieldToColumn = (field) => {
  return {
        title: field.label,
        dataIndex: field.name,
        key: field.name,
        inputType: field.type,
        editable: true,
        options: field.options,
        hidden: field.t_hide ?? false,
        render: (text) => (
          <span>
           {field.type === 'date' ?  moment(text, 'YYYY-MM-DD').isValid() ? moment(text, 'YYYY-MM-DD').format('DD/MM/YYYY') : '' :
             field.type === 'remotesearch' ? textForRemoteSearch(text) : field.type === "select" || field.type === "radio" ? field.options.find(el => el.key === text)?.label : text}
          </span>
        ),
      }
}


const textForRemoteSearch = (value) => {
  let result = "";
  if(Array.isArray(value))
    value.map((o, index) => {
      result += o.label+ ", ";
    })
  else
    result = value;
  return result
}
export const transformColumnForm = (column, index) => {
  column.key = index;
  return column;
}